import * as React from "react";

export const useInterval = (
    callback: () => void,
    delay: number,
    immediate?: boolean,
    dependencies?: any[]
) => {
    const savedCallback = React.useRef({} as any);
    const [_isRunning, setIsRunning] = React.useState(true);
    const hasFirstRun = React.useRef(false);

    const start = () => {
        if (!_isRunning) {
            setIsRunning(true);
        }
    };

    const stop = () => {
        if (_isRunning) {
            setIsRunning(false);
        }
    };

    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    React.useEffect(() => {
        if (immediate && !hasFirstRun.current) {
            savedCallback.current();
            hasFirstRun.current = true;
        }

        const tick = () => {
            hasFirstRun.current = true;
            savedCallback.current();
        };

        if (delay !== null && _isRunning) {
            // tslint:disable-next-line:prefer-const
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delay, immediate, dependencies]);

    return { start, stop };
};

export const useTimeout = (
    callback: () => void,
    delay: number,
    dependencies?: any[]
) => {
    const savedCallback = React.useRef({} as any);

    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    React.useEffect(() => {
        let id;
        const tick = () => {
            savedCallback.current();
        };

        if (delay !== null) {
            id = setTimeout(tick, delay);
        }
        return () => clearTimeout(id);
    }, [delay, dependencies]);
};
